import { Routes } from '@angular/router';
import { Home, Login } from './pages';

export const routes: Routes = [
  {
    path: '',
    component: Home,
    data: { titleKey: 'home.meta.title', descriptionKey: 'home.meta.description' },
  },
  {
    path: 'programmes',
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/programmes/programmes').then((m) => m.Programmes),
        data: {
          titleKey: 'programmes.meta.title',
          descriptionKey: 'programmes.meta.description',
        },
      },
      {
        path: ':slug',
        loadComponent: () => import('./pages/programme/programme').then((m) => m.Programme),
        data: {
          titleKey: 'programme.meta.title',
          descriptionKey: 'programme.meta.description',
        },
      },
    ],
  },
  {
    path: 'login',
    component: Login,
    data: { titleKey: 'login.meta.title', descriptionKey: 'login.meta.description' },
  },
];
